import {
  Box,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import * as React from "react";
import { useGetOne } from "react-admin";
import CustomMessage from "../../unit/CustomMessage";
import CustomPaper from "../../unit/CustomPaper";
import CustomTable from "../../unit/CustomTable";
import CustomTableContainer from "../../unit/CustomTableContainer";
import formatCurrency from "../../unit/formatCurrency";
import formatDate from "../../unit/formatDate";
import useNotify from "../../unit/useNotify";
import NoResults from "../../unit/NoResults";
import CustomPaymentRefundDialog from "../actions/CustomPaymentRefundDialog";

const TableCellRight = styled(TableCell)({ textAlign: "right" });

const RePaymentsTr = ({ ...props }) => {
  const [showDetail, setShowDetail] = React.useState(false);
  const data = props.data;
  const appId = props.appId;
  const type = props.type;
  if (type == "actualPayments") {
    // console.log("data===================>>>>>>", data);
    return (
      <>
        <TableRow
          key={`transfer_` + data.iId}
          sx={{
            "& td":
              data.dLastActualPaidDate &&
              data.dLastActualPaidDate != "0000-00-00 00:00:00" &&
              data.dateType == "initdate"
                ? { cursor: "pointer" }
                : {},
            // backgroundColor: "#e2efda",
          }}
          className={type}
          onClick={() => setShowDetail(!showDetail)}
        >
          <TableCell>Repayment</TableCell>
          {/* <TableCell>
            {data.dateType == "initdate"
              ? "Date Payment Made"
              : "Date Payment Received"}
          </TableCell> */}
          <TableCell align="left">
            {data.dLastActualPaidDate &&
              data.dLastActualPaidDate != "0000-00-00 00:00:00" &&
              formatDate(data.dLastActualPaidDate)}
          </TableCell>
          <TableCell className="amountText">
            {formatCurrency(data.dActualAmountPaid)}
            {/* add refund icon */}
            {data.dActualAmountPaid > 0 &&
              data.sCorrelationId &&
              // && item.dLastActualPaidDate 在31天内
              new Date(data.dLastActualPaidDate) >=
                new Date(new Date().setDate(new Date().getDate() - 31)) && (
                <CustomPaymentRefundDialog
                  paymentId={data.iActualPaymentNum}
                  appId={appId}
                  amount={data.dActualAmountPaid}
                  data={data}
                  sx={{
                    ml: 1,
                    fontSize: "1.2rem",
                    verticalAlign: "middle",
                    width: "32px",
                  }}
                />
              )}

            {new Date(data.dLastActualPaidDate) <
              new Date(new Date().setDate(new Date().getDate() - 31)) && (
              <Box
                sx={{
                  ml: 1,
                  width: "32px",
                  display: "inline-block",
                  visibility: "hidden", // 隐藏但占位
                }}
              >
                {/* 占位符 - 透明图标或空白 */}
              </Box>
            )}
          </TableCell>
          {/* <TableCell className="amountText">
            {formatCurrency(data.interestAmount)}
          </TableCell> */}
          {/* <TableCell className="amountText">
            {formatCurrency(data.principalReduction)}
          </TableCell> */}
          <TableCell>
            {!data.sCorrelationId ? (
              <>
                Offline
                {/* <span
                  className="repaymentRelatedId"
                  style={{ marginLeft: "15px" }}
                >
                  [{data.iId}]
                </span> */}
                <span
                  className="actionBankerEmail"
                  style={{ marginLeft: "15px" }}
                >
                  [{data?.actionBanker}]
                </span>
              </>
            ) : (
              <>
                {data.sOwner == "USER" ? (
                  <>Borrower</>
                ) : data.sOwner == "SYSTEM" ? (
                  <>Automatic ACH</>
                ) : (
                  <>{data.sOwner ? data.sOwner : "Automatic ACH"}</>
                )}
              </>
            )}
          </TableCell>
          <TableCell>
            {data.sCorrelationId ? (
              <span
                className="repaymentRelatedId"
                style={{ marginLeft: "0px" }}
              >
                {data.sCorrelationId}
              </span>
            ) : (
              <span
                className="repaymentRelatedId"
                style={{ marginLeft: "0px" }}
              >
                {/* {data.iId} */}
                {!data.sCorrelationId && (
                  <>
                    {formatDate(data?.actionCreated)}: {data?.sComment}
                  </>
                )}
              </span>
            )}
          </TableCell>
        </TableRow>
      </>
    );
  } else if (type == "Paid-Off") {
    return (
      <TableRow
        key={`paidoff_` + data.iId}
        sx={{ "& td": { backgroundColor: "#fffcd0" } }}
        className={type}
      >
        <TableCell>{type}</TableCell>
        <TableCell className="dateText">
          {formatDate(data.payoffdate)}
        </TableCell>
        <TableCell>Paid Off Amount</TableCell>
        <TableCell className="amountText">
          {formatCurrency(data.payoffamount)}
        </TableCell>

        <TableCell></TableCell>
        <TableCell></TableCell>
        <TableCell></TableCell>
      </TableRow>
    );
  } else if (type == "refundPayments" && data.sStatus == "succeed") {
    return (
      <TableRow
        key={`refund_` + data.iId}
        sx={{ "& td": { backgroundColor: "#eee" } }}
        className={type}
      >
        <TableCell>Refund</TableCell>
        <TableCell>Date Payment Refunded</TableCell>
        <TableCell className="dateText">
          {formatDate(data.dTransferDate)}
        </TableCell>
        <TableCell>Amount Refunded</TableCell>
        <TableCell className="amountText">
          {formatCurrency(data.dAmount)}
        </TableCell>
        <TableCell>
          {data.sActionType == "refundPaidOff" ? (
            <>
              {data.sOffline == "Yes" ? <>Offline</> : <>Manual ACH</>}
              <span
                className="repaymentRelatedId"
                style={{ marginLeft: "15px" }}
              >
                [{data.iId}]
              </span>
            </>
          ) : (
            <>Manual ACH</>
          )}
        </TableCell>
        <TableCell></TableCell>
      </TableRow>
    );
  } else {
    return <></>;
  }
};

const LoanPaymentsMadeTable = ({ ...props }) => {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const appId = props.appId;
  const { data, error, isLoading, isPending, isFetching } = useGetOne(
    "loan/paymentschedule/paymentmade",
    { id: appId }
  );
  if (isPending || isFetching) {
    return <Typography sx={{ p: 5 }}>Loading...</Typography>;
  }
  if (error) return <CustomMessage message="Error loading Loan" />;
  if (!data) return <CustomMessage message="No data found for this id" />;

  const disbursement = data?.disbursement;
  const transferDisbursementData = data?.transferDisbursementData;
  const amount_paid_borrower = data?.amount_paid_borrower;
  const amount_paid_3party = data?.amount_paid_3party;
  const amount_paid_existingloan = data?.amount_paid_existingloan;
  const transfersList = data?.transfersList;
  //change transfersList to array
  const transfersListData = Object.keys(transfersList);
  const transfersListArrayData = transfersListData.map((key) => {
    return transfersList[key];
  });

  return (
    <>
      <CustomTableContainer component={CustomPaper}>
        <CustomTable
          stickyHeader
          id="table-loan-summary-payment-log-list"
          // sx={{ tableLayout: "fixed" }}
        >
          <TableHead>
            <TableRow>
              <TableCell className="hm-table-header">Type</TableCell>
              <TableCell align="left" className="hm-table-header">
                Date Payment Made
              </TableCell>
              <TableCell
                align="right"
                className="hm-table-header"
                sx={{
                  "&.MuiTableCell-head": {
                    width: "200px !important",
                    maxWidth: "200px",
                    minWidth: "200px",
                  },
                }}
              >
                Amount
                <Box
                  sx={{
                    ml: 1,
                    width: "32px",
                    display: "inline-block",
                    visibility: "hidden", // 隐藏但占位
                  }}
                >
                  {/* 占位符 - 透明图标或空白 */}
                </Box>
              </TableCell>
              {/* <TableCell align="right" className="hm-table-header">
                Interest
              </TableCell> */}
              {/* <TableCell align="right" className="hm-table-header">
                Principal
              </TableCell> */}
              <TableCell className="hm-table-header">Method</TableCell>
              <TableCell className="hm-table-header" colSpan={3}>
                Correlation ID
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {disbursement && (
              <TableRow key={`disbursement_` + disbursement.id}>
                <TableCell>Disbursement</TableCell>
                <TableCell className="dateText" align="left">
                  {formatDate(disbursement.dFundDate)}
                </TableCell>

                {(amount_paid_3party ||
                  amount_paid_borrower ||
                  amount_paid_existingloan) && (
                  <>
                    <TableCell
                      className="amountText"
                      align="left"
                      sx={{ pr: "55px" }}
                    >
                      {amount_paid_borrower > 0 && (
                        <Typography
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <Box component="span">Amount Paid To Borrower:</Box>
                          <Box component="span" sx={{ ml: 2 }}>
                            {formatCurrency(amount_paid_borrower)}
                          </Box>
                        </Typography>
                      )}
                      {amount_paid_3party > 0 && (
                        <Typography
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <Box component="span">Amount Paid To 3rd Party:</Box>
                          <Box component="span" sx={{ ml: 2 }}>
                            {formatCurrency(amount_paid_3party)}
                          </Box>
                        </Typography>
                      )}
                      {amount_paid_existingloan > 0 && (
                        <Typography
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <Box component="span">
                            Amount Paid To Existing Loan:
                          </Box>
                          <Box component="span" sx={{ ml: 2 }}>
                            {formatCurrency(amount_paid_existingloan)}
                          </Box>
                        </Typography>
                      )}
                    </TableCell>
                  </>
                )}
                {!(
                  amount_paid_3party ||
                  amount_paid_borrower ||
                  amount_paid_existingloan
                ) && (
                  <>
                    <TableCell className="amountText">
                      {formatCurrency(disbursement.dAmount)}
                    </TableCell>
                    <TableCell>
                      {/* Amount Disbursed */}
                      {transferDisbursementData &&
                        transferDisbursementData.sOwner && (
                          <>
                            {transferDisbursementData.sOwner == "OWNER" ? (
                              <>Borrower</>
                            ) : transferDisbursementData.sOwner == "SYSTEM" ? (
                              <>Automatic ACH</>
                            ) : (
                              <>{transferDisbursementData.sOwner}</>
                            )}
                          </>
                        )}
                    </TableCell>
                  </>
                )}
                {(amount_paid_3party ||
                  amount_paid_borrower ||
                  amount_paid_existingloan) && <TableCell>&nbsp;</TableCell>}

                <TableCell>
                  {transferDisbursementData &&
                    transferDisbursementData.sOwner && (
                      <>
                        <span
                          className="repaymentRelatedId"
                          style={{ marginLeft: "0px" }}
                        >
                          {transferDisbursementData.sCorrelationId}
                        </span>
                      </>
                    )}
                  {transferDisbursementData &&
                    !transferDisbursementData.sOwner &&
                    transferDisbursementData.sCorrelationId && (
                      <span
                        className="repaymentRelatedId"
                        style={{ marginLeft: "0px" }}
                      >
                        {transferDisbursementData.sCorrelationId}
                      </span>
                    )}
                  {!transferDisbursementData && (
                    <>
                      <NoResults />
                    </>
                  )}
                </TableCell>
              </TableRow>
            )}

            {transfersListArrayData && transfersListArrayData.length > 0 ? (
              transfersListArrayData.map(
                (transfer: any, transferIndex: number) =>
                  transfer.map((item: any, itemIndex: number) => (
                    <RePaymentsTr
                      key={`repayment_${item?.type || "unknown"}_${
                        item?.data?.iId || item?.data?.iActualPaymentNum || "na"
                      }_${transferIndex}_${itemIndex}`}
                      data={item.data}
                      type={item.type}
                      appId={appId}
                    />
                  ))
              )
            ) : (
              <TableRow>
                <TableCell className="no-results">
                  <NoResults />
                </TableCell>
              </TableRow>
            )}

            {/* {!transfersList.length && !disbursement && (
            <TableRow>
              <TableCell className="no-results"><NoResults /> </TableCell>
            </TableRow>
          )} */}
          </TableBody>
        </CustomTable>
      </CustomTableContainer>
    </>
  );
};

export default LoanPaymentsMadeTable;
